<template>
  <div class="my-active-container" ref="mainContainer">
    <Header title="我的报名" />
    <MineActive :list="datas.records" v-if="datas.records.total !== 0" />
    <template v-else>
      <Empty text="暂无报名"></Empty>
    </template>
    <div
      class="loading"
      element-loading-text="加载中..."
      v-loading="isLoading"
      v-if="!isNotMore"
      :style="{ paddingTop: datas.records.total !== 0 ? 0 : '150px' }"
    ></div>
    <div class="noMore" v-if="isNotMore">——— 我是有底线的 ———</div>
  </div>
</template>
<script>
import fetchData from "@/mixins/fetchData.js";
import mainScroll from "@/mixins/mainScroll.js";
import { myActive } from "@/api/active.js";
import MineActive from "./components/MineActive";
import Header from "@/components/util/Header";
import Empty from "@/components/Empty";
export default {
  components: {
    MineActive,
    Header,
    Empty,
  },
  mixins: [fetchData({ records: { total: 0 } }), mainScroll("mainContainer")],
  data() {
    return {
      regist_status: 999,
      page: 1,
      limit: 5,
      isNotMore: false,
      storage: window.localStorage,
      icon: {
        type: "myActive",
        color: "#ee5f5c",
        size: "24",
      },
    };
  },
  created() {
    this.$bus.$on("mainScroll", this.handleScroll);
  },
  unmounted() {
    this.$bus.$off("mainScroll", this.handleScroll);
  },
  methods: {
    async fetchData() {
      return await myActive(
        this.storage.getItem("uid"),
        this.storage.getItem("usertoken"),
        this.regist_status,
        this.page,
        this.limit
      );
    },
    handleScroll(dom) {
      if (this.isLoading || !dom) {
        // 目前正在加载更多
        return;
      }
      const range = 20; // 顶一个可接受的范围，在这个范围内都算达到了底部
      const dec = Math.abs(dom.scrollTop + dom.clientHeight - dom.scrollHeight);
      if (dec <= range) {
        this.fetchMore();
      }
    }, // 加载下一页
    async fetchMore() {
      if (!this.hasMore) {
        // 没有更多啦
        return;
      }
      this.isLoading = true;
      this.page++;

      const resp = await this.fetchData();
      this.datas.records.total = resp.records.total;
      this.datas.records.data = this.datas.records.data.concat(
        resp.records.data
      );

      this.isLoading = false;
    },
  },
  computed: {
    hasMore() {
      return this.datas.records.data.length < this.datas.records.total;
    },
  },
};
</script>
<style lang="less" scoped>
@import "~@/styles/mixin.less";

.my-active-container {
  position: relative;
  margin: auto;
  overflow-x: hidden;
  overflow-y: auto;
  scroll-behavior: smooth;
  overscroll-behavior-y: none;
  height: 100%;
  width: 96%;
  padding-top: 50px;
  margin: 0 auto;
  .el-text {
    display: block;
    font-size: 16px;
    text-align: left;
    color: var(--000);
  }
}

.my-active-top-container {
  .self-flex(flex-start);
  align-items: center;
  margin: 0 3%;
}

.active-icon-container {
  .active-icon(25px);
  margin-right: 5px;
  flex: 0 0 auto;
}

.loading {
  background: transparent;
  margin: 20px 0;
  height: 20px;
}

.noMore {
  color: var(--ccc);
  margin: 20px 0;
  height: 20px;
  font-size: 14px;
}

.my-active-container .header-wrap {
  background-color: var(--f56c6c);
  color: var(--fff);
}
</style>